import {computed, shallowRef} from 'vue';
import {useTranslation} from '#imports';
import EditResumeImportStepDuplicatedExperienceList from '../ui/step/EditResumeImportStepDuplicatedExperienceList.vue';
import EditResumeImportStepExperienceList from '../ui/step/EditResumeImportStepExperienceList.vue';
import EditResumeImportStepUploadError from '../ui/step/EditResumeImportStepUploadError.vue';
import EditResumeImportStepUploadFile from '../ui/step/EditResumeImportStepUploadFile.vue';

type FunnelOrderedStep = {
    name: string;
    label: string;
    component:
        | typeof EditResumeImportStepDuplicatedExperienceList
        | typeof EditResumeImportStepExperienceList
        | typeof EditResumeImportStepUploadFile;
    errorComponent?: typeof EditResumeImportStepUploadError;
};
export function useFunnelSteps() {
    const {t} = useTranslation();

    const funnelOrderedSteps = shallowRef<FunnelOrderedStep[]>([]);

    funnelOrderedSteps.value.push({
        name: 'EditResumeImportStepUploadFile',
        label: t('profile.experience.funnel.step.upload.step_name'),
        component: EditResumeImportStepUploadFile,
        errorComponent: EditResumeImportStepUploadError,
    });

    funnelOrderedSteps.value.push({
        name: 'EditResumeImportStepDuplicatedExperienceList',
        label: t('profile.experience.funnel.step.duplicate_list.step_name'),
        component: EditResumeImportStepDuplicatedExperienceList,
    });

    funnelOrderedSteps.value.push({
        name: 'EditResumeImportStepExperienceList',
        label: t('profile.experience.funnel.step.experience_list.step_name'),
        component: EditResumeImportStepExperienceList,
    });

    const currentStep = shallowRef(funnelOrderedSteps.value[0]);
    const currentStepName = computed(() => currentStep.value?.name);
    const currentStepComponent = computed(() => currentStep.value?.component);
    const currentStepErrorComponent = computed(() => currentStep.value?.errorComponent);

    const stepperCurrentIndex = computed(() => _getCurrentStepIndex() + 1);
    const stepperStepsCount = computed(() => funnelOrderedSteps.value.length || 1);
    const hasStepNext = computed(() => {
        return _getCurrentStepIndex() < funnelOrderedSteps.value.length - 1;
    });
    const hasStepError = computed(() => {
        return !!currentStep.value.errorComponent;
    });
    function _getCurrentStepIndex(): number {
        return funnelOrderedSteps.value.findIndex((step: FunnelOrderedStep) => step.name === currentStep.value?.name);
    }

    function funnelReset(): void {
        currentStep.value = funnelOrderedSteps.value[0];
    }
    function goToStepNext(): void {
        currentStep.value = funnelOrderedSteps.value[_getCurrentStepIndex() + 1];
    }

    return {
        // refs
        currentStepName,
        currentStepComponent,
        currentStepErrorComponent,
        hasStepError,
        hasStepNext,
        funnelOrderedSteps,
        stepperCurrentIndex,
        stepperStepsCount,
        // functions
        funnelReset,
        goToStepNext,
    };
}
